'use client';

import React, { useState } from 'react';
import { MapPin, Star, Clock, ChevronRight, Heart, Share2, Shield, Zap, Award, CheckCircle } from 'lucide-react';
import BookingModal from './BookingModal';

// Backend integration point: replace with API call to GET /api/hotels?filters=...
const hotels = [
{
  id: 'hotel-001',
  name: 'Seabel Alhambra Beach Golf & Spa',
  location: 'Port El Kantaoui, Sousse',
  region: 'Sousse',
  stars: 5,
  rating: 4.8,
  reviewCount: 312,
  courts: 3,
  pricePerHour: 65,
  currency: 'TND',
  surface: 'WPT Carpet',
  indoor: false,
  floodlit: true,
  stayAndPlay: true,
  availability: 'available',
  nextSlot: '14:00',
  amenities: ['Pool', 'Spa', 'Restaurant', 'Beach'],
  image: "https://images.unsplash.com/photo-1598605272254-16f0c0ecdfa5",
  imageAlt: 'Luxury hotel pool area with turquoise water and palm trees under blue sky',
  badge: 'Top Rated',
  distance: '800m from beach',
  equipment: true,
  description: '3 professional WPT-standard courts with floodlighting. Equipment rental available. Bundled with hotel stay packages.'
},
{
  id: 'hotel-002',
  name: 'TUI BLUE Manar',
  location: 'Hammamet Nord',
  region: 'Hammamet',
  stars: 4,
  rating: 4.6,
  reviewCount: 198,
  courts: 2,
  pricePerHour: 50,
  currency: 'TND',
  surface: 'Artificial Grass',
  indoor: false,
  floodlit: true,
  stayAndPlay: true,
  availability: 'limited',
  nextSlot: '16:30',
  amenities: ['Pool', 'Beach', 'Kids Club', 'Gym'],
  image: "https://images.unsplash.com/photo-1716745558966-bcb9827e98f8",
  imageAlt: 'Modern resort hotel exterior with green gardens and clear swimming pool',
  badge: 'Stay & Play',
  distance: '200m from beach',
  equipment: true,
  description: '2 floodlit outdoor courts with artificial grass. Perfect for families and groups. Racket rental on-site.'
},
{
  id: 'hotel-003',
  name: 'Oceana Hotel & Spa',
  location: 'Hammamet Sud',
  region: 'Hammamet',
  stars: 5,
  rating: 4.7,
  reviewCount: 245,
  courts: 1,
  pricePerHour: 70,
  currency: 'TND',
  surface: 'Acrylic',
  indoor: false,
  floodlit: false,
  stayAndPlay: true,
  availability: 'available',
  nextSlot: '10:00',
  amenities: ['Spa', 'Pool', 'Private Beach', 'Fine Dining'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bead9510-1772207359070.png",
  imageAlt: 'Five-star beachfront hotel with infinity pool overlooking the Mediterranean sea',
  badge: null,
  distance: 'Beachfront',
  equipment: false,
  description: '1 premium acrylic court with sea views. Ideal for morning sessions before beach time.'
},
{
  id: 'hotel-004',
  name: 'Occidental Marhaba (Padelium)',
  location: 'Sousse Centre',
  region: 'Sousse',
  stars: 4,
  rating: 4.5,
  reviewCount: 167,
  courts: 3,
  pricePerHour: 45,
  currency: 'TND',
  surface: 'WPT Carpet',
  indoor: false,
  floodlit: true,
  stayAndPlay: false,
  availability: 'available',
  nextSlot: '09:00',
  amenities: ['Pool', 'Restaurant', 'Gym', 'Tennis'],
  image: "https://images.unsplash.com/photo-1670248549364-0fb3840b86d9",
  imageAlt: 'Mediterranean hotel courtyard with terracotta tiles and vibrant bougainvillea',
  badge: 'Best Value',
  distance: '1.2km from beach',
  equipment: true,
  description: '3 WPT-standard courts (Padelium complex). Largest padel facility in Sousse. Open to hotel guests and public.'
},
{
  id: 'hotel-005',
  name: 'Club Med Djerba La Douce',
  location: 'Midoun, Djerba',
  region: 'Djerba',
  stars: 4,
  rating: 4.4,
  reviewCount: 289,
  courts: 2,
  pricePerHour: 55,
  currency: 'TND',
  surface: 'Artificial Grass',
  indoor: false,
  floodlit: true,
  stayAndPlay: true,
  availability: 'limited',
  nextSlot: '15:00',
  amenities: ['All-Inclusive', 'Beach', 'Kids Club', 'Water Sports'],
  image: "https://images.unsplash.com/photo-1696874575413-2463103c0ade",
  imageAlt: 'All-inclusive resort beach club with white umbrellas and turquoise Mediterranean water',
  badge: 'All-Inclusive',
  distance: 'Private beach',
  equipment: true,
  description: '2 floodlit courts included in all-inclusive package. Coaching clinics available twice weekly.'
},
{
  id: 'hotel-006',
  name: 'Hotel Sentido Bellevue Park',
  location: 'Port El Kantaoui',
  region: 'Sousse',
  stars: 5,
  rating: 4.3,
  reviewCount: 134,
  courts: 1,
  pricePerHour: 60,
  currency: 'TND',
  surface: 'WPT Carpet',
  indoor: false,
  floodlit: true,
  stayAndPlay: true,
  availability: 'booked',
  nextSlot: 'Tomorrow 09:00',
  amenities: ['Spa', 'Thalasso', 'Pool', 'Beach'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_135ecaf1a-1772405652257.png",
  imageAlt: 'Elegant hotel facade with manicured gardens and ornate fountain at sunset',
  badge: null,
  distance: '500m from marina',
  equipment: false,
  description: '1 WPT carpet court. Thalasso spa and wellness packages can be bundled with padel sessions.'
},
{
  id: 'hotel-007',
  name: 'Padel House Tunisia',
  location: 'Ariana, Tunis',
  region: 'Tunis',
  stars: 0,
  rating: 4.9,
  reviewCount: 411,
  courts: 3,
  pricePerHour: 35,
  currency: 'TND',
  surface: 'Artificial Grass',
  indoor: true,
  floodlit: true,
  stayAndPlay: false,
  availability: 'available',
  nextSlot: '11:00',
  amenities: ['Parking', 'Café', 'Pro Shop', 'Coaching'],
  image: "https://images.unsplash.com/photo-1709587825415-814c2d7cfce7",
  imageAlt: 'Indoor padel court with green artificial grass surface and glass walls under bright lights',
  badge: 'Indoor',
  distance: 'Ariana Superville',
  equipment: true,
  description: '3 indoor courts with professional artificial grass. Air-conditioned. Best rated standalone club in Tunisia.'
},
{
  id: 'hotel-008',
  name: 'Padel Club Sidi Bou Said',
  location: 'Parc Municipal, Sidi Bou Said',
  region: 'Tunis',
  stars: 0,
  rating: 4.6,
  reviewCount: 178,
  courts: 2,
  pricePerHour: 40,
  currency: 'TND',
  surface: 'WPT Carpet',
  indoor: false,
  floodlit: true,
  stayAndPlay: false,
  availability: 'available',
  nextSlot: '08:00',
  amenities: ['Panoramic Views', 'Parking', 'Coaching'],
  image: "https://images.unsplash.com/photo-1613466576585-a030f12d60da",
  imageAlt: 'Outdoor sports court with panoramic Mediterranean sea view and blue sky',
  badge: 'Panoramic',
  distance: 'Sidi Bou Said village',
  equipment: true,
  description: '2 SUPERPRO PANORAMIQUE courts with MONDO WPT carpets. Breathtaking views over the Bay of Tunis.'
},
{
  id: 'hotel-009',
  name: 'Padel Resort Rafraf',
  location: 'Rafraf, Bizerte',
  region: 'Bizerte',
  stars: 3,
  rating: 4.2,
  reviewCount: 89,
  courts: 2,
  pricePerHour: 30,
  currency: 'TND',
  surface: 'Artificial Grass',
  indoor: false,
  floodlit: false,
  stayAndPlay: true,
  availability: 'available',
  nextSlot: '09:30',
  amenities: ['Pool', 'Beach', 'BBQ Area'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e4b274c4-1772221388658.png",
  imageAlt: 'Boutique resort hotel with terracotta architecture surrounded by Mediterranean vegetation',
  badge: null,
  distance: 'Beachfront',
  equipment: false,
  description: '2 outdoor courts in a relaxed beach resort setting. Ideal for weekend getaways from Tunis.'
}];


const availabilityConfig: Record<string, {label: string;color: string;dot: string;}> = {
  available: { label: 'Available Now', color: 'text-green-700 bg-green-50 border-green-200', dot: 'bg-green-500' },
  limited: { label: 'Limited Slots', color: 'text-amber-700 bg-amber-50 border-amber-200', dot: 'bg-amber-500' },
  booked: { label: 'Fully Booked', color: 'text-red-700 bg-red-50 border-red-200', dot: 'bg-red-400' }
};

export default function HotelGrid() {
  const [selectedHotel, setSelectedHotel] = useState<typeof hotels[0] | null>(null);
  const [wishlist, setWishlist] = useState<Set<string>>(new Set());
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const toggleWishlist = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setWishlist((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
        {hotels.map((hotel) => {
          const avail = availabilityConfig[hotel.availability];
          const isHovered = hoveredId === hotel.id;
          return (
            <div
              key={hotel.id}
              onMouseEnter={() => setHoveredId(hotel.id)}
              onMouseLeave={() => setHoveredId(null)}
              className={`bg-white rounded-2xl border border-border overflow-hidden cursor-pointer transition-all duration-200 ${
              isHovered ? 'shadow-card-hover -translate-y-0.5' : 'shadow-card'}`
              }>
              
              {/* Image */}
              <div className="relative h-48 overflow-hidden bg-muted">
                <img
                  src={hotel.image}
                  alt={hotel.imageAlt}
                  className={`w-full h-full object-cover transition-transform duration-300 ${isHovered ? 'scale-105' : 'scale-100'}`} />
                
                {/* Overlay badges */}
                <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                  {hotel.badge &&
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-secondary text-secondary-foreground shadow-sm">
                      {hotel.badge}
                    </span>
                  }
                  {hotel.stayAndPlay &&
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-primary text-primary-foreground shadow-sm">
                      Stay & Play
                    </span>
                  }
                  {hotel.indoor &&
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-600 text-white shadow-sm">
                      Indoor
                    </span>
                  }
                </div>
                {/* Actions */}
                <div className="absolute top-3 right-3 flex gap-1.5">
                  <button
                    onClick={(e) => toggleWishlist(hotel.id, e)}
                    className="w-8 h-8 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-sm hover:bg-white transition-colors">
                    
                    <Heart
                      size={15}
                      className={wishlist.has(hotel.id) ? 'fill-red-500 text-red-500' : 'text-muted-foreground'} />
                    
                  </button>
                  <button
                    onClick={(e) => e.stopPropagation()}
                    className="w-8 h-8 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-sm hover:bg-white transition-colors">
                    
                    <Share2 size={14} className="text-muted-foreground" />
                  </button>
                </div>
                {/* Stars */}
                {hotel.stars > 0 &&
                <div className="absolute bottom-3 left-3">
                    <span className="flex gap-0.5">
                      {Array.from({ length: hotel.stars }).map((_, i) =>
                    <Star key={`star-${hotel.id}-${i}`} size={11} className="fill-secondary text-secondary" />
                    )}
                    </span>
                  </div>
                }
              </div>

              {/* Content */}
              <div className="p-4">
                {/* Header */}
                <div className="flex items-start justify-between gap-2 mb-2">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base font-semibold text-foreground leading-tight truncate">{hotel.name}</h3>
                    <div className="flex items-center gap-1 mt-1 text-sm text-muted-foreground">
                      <MapPin size={12} className="flex-shrink-0" />
                      <span className="truncate">{hotel.location}</span>
                    </div>
                  </div>
                  <div className="flex-shrink-0 text-right">
                    <div className="flex items-center gap-1 justify-end">
                      <Star size={13} className="fill-secondary text-secondary" />
                      <span className="text-sm font-semibold text-foreground tabular-nums">{hotel.rating}</span>
                    </div>
                    <p className="text-xs text-muted-foreground tabular-nums">{hotel.reviewCount} reviews</p>
                  </div>
                </div>

                {/* Meta row */}
                <div className="flex flex-wrap gap-2 mb-3">
                  <span className="flex items-center gap-1 text-xs font-medium text-muted-foreground bg-muted px-2.5 py-1 rounded-full">
                    <Shield size={11} />
                    {hotel.courts} Court{hotel.courts > 1 ? 's' : ''}
                  </span>
                  <span className="flex items-center gap-1 text-xs font-medium text-muted-foreground bg-muted px-2.5 py-1 rounded-full">
                    <Zap size={11} />
                    {hotel.surface}
                  </span>
                  {hotel.floodlit &&
                  <span className="flex items-center gap-1 text-xs font-medium text-muted-foreground bg-muted px-2.5 py-1 rounded-full">
                      <Award size={11} />
                      Floodlit
                    </span>
                  }
                  {hotel.equipment &&
                  <span className="flex items-center gap-1 text-xs font-medium text-muted-foreground bg-muted px-2.5 py-1 rounded-full">
                      <CheckCircle size={11} />
                      Equipment
                    </span>
                  }
                </div>

                {/* Amenities */}
                <div className="flex flex-wrap gap-1 mb-3">
                  {hotel.amenities.slice(0, 4).map((a) =>
                  <span key={`amen-${hotel.id}-${a}`} className="text-xs text-muted-foreground/80">
                      {a}
                    </span>
                  )}
                  {hotel.amenities.length > 4 &&
                  <span className="text-xs text-muted-foreground/60">+{hotel.amenities.length - 4} more</span>
                  }
                </div>

                {/* Availability + Price + CTA */}
                <div className="flex items-center justify-between pt-3 border-t border-border">
                  <div>
                    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${avail.color}`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${avail.dot}`} />
                      {avail.label}
                    </div>
                    {hotel.availability !== 'booked' &&
                    <div className="flex items-center gap-1 mt-1 text-xs text-muted-foreground">
                        <Clock size={11} />
                        <span>Next: {hotel.nextSlot}</span>
                      </div>
                    }
                  </div>

                  <div className="text-right">
                    <div className="flex items-baseline gap-1 justify-end">
                      <span className="text-xl font-bold text-foreground font-mono tabular-nums">{hotel.pricePerHour}</span>
                      <span className="text-sm font-medium text-muted-foreground">TND/hr</span>
                    </div>
                    <button
                      onClick={() => hotel.availability !== 'booked' && setSelectedHotel(hotel)}
                      disabled={hotel.availability === 'booked'}
                      className={`mt-2 flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold transition-all duration-150 ${
                      hotel.availability === 'booked' ? 'bg-muted text-muted-foreground cursor-not-allowed' : 'bg-primary text-primary-foreground hover:bg-primary/90 active:scale-95 shadow-sm'}`
                      }>
                      
                      {hotel.availability === 'booked' ? 'Fully Booked' : 'Book Now'}
                      {hotel.availability !== 'booked' && <ChevronRight size={14} />}
                    </button>
                  </div>
                </div>
              </div>
            </div>);

        })}
      </div>

      {/* Load more */}
      <div className="mt-10 text-center">
        <button className="px-8 py-3 rounded-xl border border-border bg-white text-sm font-semibold text-muted-foreground hover:text-foreground hover:border-primary/40 hover:bg-muted/30 transition-all duration-150">
          Load More Courts
        </button>
        <p className="mt-2 text-xs text-muted-foreground">Showing 9 of 32 courts</p>
      </div>

      {/* Booking Modal */}
      {selectedHotel &&
      <BookingModal hotel={selectedHotel} onClose={() => setSelectedHotel(null)} />
      }
    </>);

}